import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9.83 23L17 15.82V3H4.69L1 11.6V16h8.31l-1.12 5.38zM19 3h4v12h-4z"
}), 'ThumbDownSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ThumbDownSharp.js
// module id = 6782
// module chunks = 2